const initialState = 'ascending';
const changeOrder = (state = initialState, action) =>{
    switch(action.type){
        case 'ASCENDING' :
            return 'ascending';
        case 'DESCENDING' : 
            return  'descending';
        default: 
            return state;
    }
}
export default changeOrder;